import React, { Component } from "react";
import ApiManager from "../../../managers/ApiManager";

import { DKLabel, showToast, TOAST_TYPE } from "deskera-ui-library";
import sanitizeSVG from '@mattkrick/sanitize-svg';
/*
PROPS
- data // this is current componets data
- onDataChange
- className
*/

class ImagePicker extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }
  render() {
    return (
      <div
        className={
          "column p-r border-radius-s border-m bg-white shadow-s border-box parent-width overflow-hidden " +
          this.props.className
        }
      >
        <DKLabel text="Select image" className="fw-m mb-m" />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            this.uploadImageToAWS(e.target.files[0]);
          }}
        />
      </div>
    );
  }

  async uploadImageToAWS(imageData) {
    const cleanImage = await sanitizeSVG(imageData)
    if (!cleanImage) {
        showToast("Image upload failed,seems like a malicious file. Please try uploading another image.", TOAST_TYPE.FAILURE);
        return;
    }
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        this.changeValue(url);
      },
      (err) => {
        showToast("Image upload failed", TOAST_TYPE.FAILURE);
      }
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////

  changeValue = (imageURL) => {
    this.componentData.value = imageURL;
    this.props.onDataChange(this.componentData);
  };
}

export default ImagePicker;
